/** Mermaid diagram definitions keyed by id. */
export const diagrams: Record<string, string> = {
  systemOverview: `flowchart TB
  subgraph browser [Browser]
    User[Shopper / Crawler]
  end
  subgraph storefront [FastStore Storefront]
    FS[Next.js 15]
  end
  subgraph vtex [VTEX Platform]
    TG["tenant-graphql<br/>/_v/private/graphql/v1"]
    Bridge[faststore-unbxd-bridge]
  end
  subgraph external [External Services]
    Unbxd[search.unbxd.io]
    Catalog[VTEX Catalog API]
    NativeIS[VTEX Intelligent Search]
  end
  User --> FS
  FS --> TG
  TG --> Bridge
  Bridge --> Unbxd
  Bridge --> Catalog
  FS -.->|fallback| NativeIS`,

  graphqlLayers: `flowchart TB
  subgraph sf [FastStore Storefront]
    GSSP[Server prefetch GSSP / GSP]
    ClientGQL["Client /api/graphql<br/>Query.search"]
    Transport[unbxdBridge.ts transport]
  end
  subgraph vp [VTEX Platform]
    Agg[tenant-graphql aggregator]
    Resolver["faststoreSearch<br/>faststoreRedirect"]
  end
  subgraph ext [External]
    UnbxdAPI[Unbxd Search API]
    VtexCat[Catalog hydration]
  end
  GSSP --> Transport
  ClientGQL --> Transport
  Transport --> Agg
  Agg --> Resolver
  Resolver --> UnbxdAPI
  Resolver --> VtexCat`,

  searchFlow: `sequenceDiagram
  participant U as Shopper
  participant G as /s GSSP
  participant B as Bridge
  participant UN as Unbxd
  participant CAT as VTEX Catalog
  participant SW as Browser SWR

  U->>G: GET /s?q=mens+shoes
  G->>B: fetchUnbxdSearch
  B->>UN: search API
  UN-->>B: products + facets
  B->>CAT: hydrate productIds
  CAT-->>B: catalog rows
  B-->>G: FsSearchResult
  G-->>U: HTML + product cards
  U->>SW: hydrate from SSR seed
  Note over U,SW: Filter / sort changes
  SW->>B: client GraphQL fetch`,

  plpFlow: `flowchart TD
  A["GET /category-slug"] --> B["getStaticProps"]
  B --> C["VTEX collection lookup"]
  C --> D["Build category facets"]
  D --> E["fetchServerManyProducts"]
  E --> F{"Unbxd enabled?"}
  F -->|yes| G["Bridge category endpoint"]
  F -->|no| H["Native VTEX IS"]
  G --> I["ProductListing + gallery"]
  H --> I`,

  landingFlow: `sequenceDiagram
  participant CMS as VTEX CMS
  participant GSP as slug GSP
  participant P as prefetchUnbxdLanding
  participant B as Bridge
  participant LP as LandingPage
  participant S as UnbxdSearchResult

  CMS->>GSP: landing slug + sections
  GSP->>P: find UnbxdSearchResult section
  P->>B: fetchUnbxdSearch
  B-->>P: FsSearchResult
  P-->>GSP: searchSsr payload
  GSP-->>LP: globalSettings seed
  LP->>S: nested PageProvider
  S-->>S: render gallery + filters`,

  cacheLayers: `flowchart TB
  L1["L1 CDN / Page HTTP"] --> L2["L2 Browser SWR"]
  L2 --> L3["L3 Storefront server"]
  L3 --> L4["L4 Bridge worker memory"]
  L4 --> L5["L5 Bridge DTO policy"]`,

  resilience: `flowchart TD
  A[Search request] --> B{ENABLE_UNBXD_SEARCH?}
  B -->|false| N1[Native VTEX IS]
  B -->|true| C[Bridge call]
  C --> D{Circuit open?}
  D -->|yes| N2[Native fallback]
  D -->|no| E{Success?}
  E -->|yes| R[Unbxd results]
  E -->|retryable| F[Retry with backoff]
  F --> C
  E -->|fatal| N3[Native fallback]`,
}
